import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PlatformAdmin {
    token: string;
    userId: string;
    name: string;
    email: string;
}

interface PlatformAuthCtx {
    admin: PlatformAdmin | null;
    login: (admin: PlatformAdmin) => void;
    logout: () => void;
}

const Ctx = createContext<PlatformAuthCtx>({ admin: null, login: () => {}, logout: () => {} });

export function PlatformAuthProvider({ children }: { children: ReactNode }) {
    const [admin, setAdmin] = useState<PlatformAdmin | null>(() => {
        try {
            const stored = localStorage.getItem('br_platform_admin');
            return stored ? JSON.parse(stored) : null;
        } catch {
            return null;
        }
    });

    const login = (a: PlatformAdmin) => {
        localStorage.setItem('br_platform_token', a.token);
        localStorage.setItem('br_platform_admin', JSON.stringify(a));
        setAdmin(a);
    };

    const logout = () => {
        localStorage.removeItem('br_platform_token');
        localStorage.removeItem('br_platform_admin');
        setAdmin(null);
    };

    return <Ctx.Provider value={{ admin, login, logout }}>{children}</Ctx.Provider>;
}

export const usePlatformAuth = () => useContext(Ctx);
